import "./App.css";
import Header from "./Header";
import MainContent from "./MainContent";

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <MainContent />
    </div>
  );
}

export default App;
